/**
 * RESPONSIBILITY: which sections make up the Children's Ministry page, and in what order.
 *
 * Seven bands, seven sections, seven pencils — each one opening only what it draws.
 * The events band is the exception worth naming: it reads the ONE events list, and its
 * own section says nothing but which tag to draw from.
 */
import { SectionName, type EventRow } from '@app/sections';
import { SectionUpdate } from '../cms';
import {
  Crumbs, ChildrenHero, ChildrenIntro, ChildrenAges, ChildrenFaq, ChildrenTeam,
  ChildrenEvents, ChildrenCta,
} from '../site';

export function ChildrenPage({ events }: { events: EventRow[] }) {
  return (
    <main>
      <Crumbs trail={[{ label: 'Ministries' }, { label: 'Children' }]} />

      <SectionUpdate name={SectionName.ChildrenHero}>
        {(c) => <ChildrenHero c={c} />}
      </SectionUpdate>

      <SectionUpdate name={SectionName.ChildrenIntro}>
        {(c) => <ChildrenIntro c={c} />}
      </SectionUpdate>

      <SectionUpdate name={SectionName.ChildrenAges}>
        {(c) => <ChildrenAges c={c} />}
      </SectionUpdate>

      <SectionUpdate name={SectionName.ChildrenFaq}>
        {(c) => <ChildrenFaq c={c} />}
      </SectionUpdate>

      <SectionUpdate name={SectionName.ChildrenTeam}>
        {(c) => <ChildrenTeam c={c} />}
      </SectionUpdate>

      <SectionUpdate name={SectionName.ChildrenEvents}>
        {(c) => (
          <ChildrenEvents
            c={c}
            events={events
              .filter((e) => !c.eventCategory || (e.categories ?? []).includes(c.eventCategory))
              .slice(0, c.count || 3)}
          />
        )}
      </SectionUpdate>

      <SectionUpdate name={SectionName.ChildrenCta}>
        {(c) => <ChildrenCta c={c} />}
      </SectionUpdate>
    </main>
  );
}
